// src/pages/Home.jsx
import React, { useEffect } from 'react';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';

import HeroSection from '../components/home/HeroSection';
import FounderSection from '../components/home/FounderSection';
import AboutSection from '../components/home/AboutSection';
import ServicesSection from '../components/home/ServicesSection';
import RetreatsSection from '../components/home/RetreatsSection';
import ProgramsSection from '../components/home/ProgramsSection';
import BannerSection from '../components/home/BannerSection';
import NutritionSection from '../components/home/NutritionSection';
import GallerySection from '../components/home/GallerySection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import ContactSection from '../components/home/ContactSection';
import VideoTestimonialsSection from '../components/home/VideoTestimonialsSection';
const Home = () => {
  // Global scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-0 md:pt-0">
        <HeroSection />
        <FounderSection />
        <AboutSection />
        <ServicesSection />
        <RetreatsSection />
        <ProgramsSection />
        <BannerSection />
        <NutritionSection />
        <GallerySection />
        <TestimonialsSection />
        <ContactSection />
        <VideoTestimonialsSection/>
      </main>
      <Footer />
    </div>
  );
};

export default Home;